import { render, staticRenderFns } from "./Doa.vue?vue&type=template&id=6cc8596d&scoped=true&lang=pug&"
import script from "./Doa.vue?vue&type=script&lang=js&"
export * from "./Doa.vue?vue&type=script&lang=js&"
import style0 from "./Doa.vue?vue&type=style&index=0&id=6cc8596d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc8596d",
  null
  
)

export default component.exports